export const BILLING_PROVIDERS = Object.freeze({
  DIRECT: "direct",
  GOOGLE_PLAY: "google_play",
  APPLE: "apple",
  TELECOM_PARTNER: "telecom_partner",
  OTHER_PARTNER: "other_partner",
  UNKNOWN: "unknown",
});

export const BILLING_PROVIDER_OPTIONS = Object.freeze([
  { id: "direct", value: BILLING_PROVIDERS.DIRECT, label: "Doğrudan bu platforma ödüyorum" },
  { id: "google-play", value: BILLING_PROVIDERS.GOOGLE_PLAY, label: "Google Play üzerinden ödüyorum" },
  { id: "apple", value: BILLING_PROVIDERS.APPLE, label: "Apple App Store üzerinden ödüyorum" },
  { id: "telecom-partner", value: BILLING_PROVIDERS.TELECOM_PARTNER, label: "Telefon / internet faturama yansıyor" },
  { id: "other-partner", value: BILLING_PROVIDERS.OTHER_PARTNER, label: "Başka bir iş ortağı üzerinden ödüyorum" },
  { id: "unknown", value: BILLING_PROVIDERS.UNKNOWN, label: "Emin değilim" },
]);

export function getBillingProviderOptions(companyId) {
  if (companyId !== "max") return BILLING_PROVIDER_OPTIONS;
  const byValue = Object.fromEntries(BILLING_PROVIDER_OPTIONS.map((option) => [option.value, option]));
  return [
    { ...byValue.direct, label: "Max tarafından faturalandırılıyorum" },
    byValue.apple,
    byValue.google_play,
    { ...byValue.other_partner, id: "hepsiburada-premium", testId: "other_partner", label: "Hepsiburada Premium üzerinden ödüyorum" },
    { ...byValue.other_partner, id: "other-provider", testId: "other-provider", label: "Başka bir sağlayıcı üzerinden ödüyorum" },
    byValue.unknown,
  ];
}

export function isDigitalInstitutionContext(context) {
  return context?.category === "digital";
}
